import { AttachmentEndpoint } from '../endpoints/AttachmentEndpoint';
import { EncryptionAttachmentEntity } from '../entities/EncryptionAttachment';
import { authResource } from './Auth';
import { schema } from '@data-client/rest';
export const AttachmentResource = authResource({
    path: '/attachments/:id',
    searchParams: {},
    schema: EncryptionAttachmentEntity,
    Endpoint: AttachmentEndpoint
})
    .extend('getList', {
    schema: {
        count: 0,
        items: new schema.Collection([EncryptionAttachmentEntity])
    }
})
    .extend((BaseResource) => ({
    getBulkList: BaseResource.getList.extend({
        method: 'POST',
        body: {},
        schema: {
            count: 0,
            items: new schema.Collection([EncryptionAttachmentEntity])
        },
        sideEffect: false
    })
}));
